export const IMMUNIZATION_STATUS = {
  compliant: {
    styles: {
      backgroundColor: "var(--bs-success)",
      border: "1px solid var(--bs-success)",
      color: "white",
    },
    subtext: "All necessary immunizations completed"
  },
  compliant_with_exemptions: {
    styles: {
      backgroundColor: "var(--bs-info)",
      border: "1px solid var(--bs-info)",
      color: "white",
    },
    subtext: "Compliant with exemptions"
  },
  conditional: {
    styles: {
      backgroundColor: "var(--bs-purple)",
      border: "1px solid var(--bs-purple)",
      color: "white",
    },
    subtext: "Some immunizations are conditional"
  },
  medically_exempt: {
    styles: {
      backgroundColor: "var(--bs-warning)",
      border: "1px solid var(--bs-warning)",
      color: "white",
    },
    subtext: "Medically exempt from immunizations"
  },
  non_medically_exempt: {
    styles: {
      backgroundColor: "var(--bs-primary)",
      border: "1px solid var(--bs-primary)",
      color: "white",
    },
    subtext: "Non-medically exempt from immunizations"
  },
  pending: {
    styles: {
      backgroundColor: "var(--bs-purple)",
      border: "1px solid var(--bs-purple)",
      color: "white",
    },
    subtext: "Calculating compliance status"
  },
  multiple_matches: {
    styles: {
      backgroundColor: "var(--bs-yellow)",
      border: "1px solid var(--bs-yellow)",
      color: "white",
    },
    subtext: "Multiple matches found in registry"
  },
  overdue: {
    styles: {
      backgroundColor: "var(--bs-danger)",
      border: "1px solid var(--bs-danger)",
      color: "white",
    },
    subtext: "One or more immunizations overdue"
  },
  no_records: {
    styles: {
      backgroundColor: "var(--bs-danger)",
      border: "1px solid var(--bs-danger)",
      color: "white",
    },
    subtext: "Please collect full immunization history"
  }
};
